export const notificationTypes = {
    info: 'info',
    warning: 'warning',
    error: 'error',
    success: 'success'
}